// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2cTps","copyright":"Footer_copyright__2ydzf","inlineIcon":"Footer_inlineIcon__27QVt"};